// Visible FAQ copy and the JSON-LD graph. Keep these in one place so the
// FAQPage schema cannot drift from the questions on the page.

export const faqs = [
    {
        question: "How does the EpiQCase attach to my phone?",
        answer: "The EpiQCase uses a strong adhesive backing that securely attaches to the back of your phone, your phone case, a wall, or any flat surface."
    },
    {
        question: "Will it fit my Auvi-Q auto-injector?",
        answer: "Yes, the EpiQCase is specifically designed to fit all Auvi-Q auto-injectors perfectly, ensuring a secure fit while maintaining quick access. Auvi-Q is not included."
    },
    {
        question: "How quickly can I access my auto-injector?",
        answer: "The EpiQCase allows for instant access to your auto-injector when needed, with a quick-release design and one-handed operation. Simply pull the Auvi-Q out when needed."
    },
    {
        question: "What is the EpiQCase made of?",
        answer: "EpiQCase is made out of PLA plastic, designed to be durable and impact-resistant. It measures W: 2.5in x L: 0.8in x H: 3.5in."
    },
    {
        question: "How much does EpiQCase cost?",
        answer: "$15.99 · Free shipping · 30-day money-back guarantee · Auvi-Q not included."
    },
    {
        question: "What is your return policy?",
        answer: "We offer a 30-day satisfaction guarantee. If you're not completely satisfied with your EpiQCase, you can return it for a full refund."
    },
    {
        question: "How should I store my auto-injector?",
        answer: "Store your auto-injector per the manufacturer's instructions and avoid extreme heat, such as a hot car."
    },
    {
        question: "Is EpiQCase a medical device?",
        answer: "EpiQCase is a carrying accessory, not a medical device. Not affiliated with or endorsed by kaléo, maker of Auvi-Q."
    }
];

const ORG_ID = "https://www.epiqcase.com/#org";

export function structuredDataForPath(pathname) {
    const byType = Object.fromEntries(
        structuredData['@graph'].map((node) => [node['@type'], node])
    );
    const graph = [byType.Organization];
    if (pathname === '/' || pathname === '/Home' || pathname === '/Purchase') {
        graph.push(byType.Product);
    }
    if (pathname === '/' || pathname === '/Home') {
        graph.push(byType.FAQPage);
    }
    return {
        '@context': 'https://schema.org',
        '@graph': graph,
    };
}

export const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
        {
            "@type": "Organization",
            "@id": ORG_ID,
            "name": "EpiQCase",
            "url": "https://www.epiqcase.com/",
            "logo": "https://www.epiqcase.com/favicon-32x32.png",
            "founder": {
                "@type": "Person",
                "name": "Max"
            },
            "sameAs": [
                "https://www.tiktok.com/@epiqcase",
                "https://www.instagram.com/epiq.case"
            ]
        },
        {
            "@type": "Product",
            "@id": "https://www.epiqcase.com/Purchase#product",
            "name": "EpiQCase – Auvi-Q Case That Sticks to Your Phone",
            "description": "EpiQCase attaches to the back of your phone so your Auvi-Q stays with you and is ready when you need it. It holds an Auvi-Q and mounts with an adhesive backing. Made of PLA plastic. Auvi-Q not included.",
            "image": "https://www.epiqcase.com/epiqcase-product.webp",
            "brand": { "@id": ORG_ID },
            "material": "PLA plastic",
            "width": { "@type": "QuantitativeValue", "value": 2.5, "unitCode": "INH" },
            "height": { "@type": "QuantitativeValue", "value": 3.5, "unitCode": "INH" },
            "depth": { "@type": "QuantitativeValue", "value": 0.8, "unitCode": "INH" },
            "isAccessoryOrSparePartFor": {
                "@type": "Product",
                "name": "AUVI-Q (epinephrine injection) auto-injector"
            },
            "offers": {
                "@type": "Offer",
                "url": "https://www.epiqcase.com/Purchase",
                "price": "15.99",
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock",
                "itemCondition": "https://schema.org/NewCondition",
                "seller": { "@id": ORG_ID },
                "shippingDetails": {
                    "@type": "OfferShippingDetails",
                    "shippingRate": {
                        "@type": "MonetaryAmount",
                        "value": "0",
                        "currency": "USD"
                    }
                },
                "hasMerchantReturnPolicy": {
                    "@type": "MerchantReturnPolicy",
                    "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
                    "merchantReturnDays": 30,
                    "refundType": "https://schema.org/FullRefund"
                }
            }
        },
        {
            "@type": "FAQPage",
            "mainEntity": faqs.map((faq) => ({
                "@type": "Question",
                "name": faq.question,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": faq.answer
                }
            }))
        }
    ]
};
